/**
 * --------------------------------------------------
 * STORE-SPECIFIC JAVASCRIPT
 * --------------------------------------------------
 * 
 * This file is reserved for store-specific scripts.
 */

(function () {
  const WISER_ATC_SELECTORS = [
    '.ws_atc_cart_text',
    '.ws_Product_Button',
  ];

  let refreshTimer = null;
  let refreshInFlight = false;

  function getCartUrl() {
    if (window.routes && window.routes.cart_url) {
      return window.routes.cart_url;
    }

    return '/cart';
  }

  function updateHeaderCartCount(cartData) {
    const count = cartData && typeof cartData.item_count === 'number' ? cartData.item_count : 0;
    const countBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

    if (count === 0) {
      countBubble?.remove();
      return;
    }

    if (countBubble) {
      countBubble.innerHTML =
        count < 100
          ? `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items in cart</span>`
          : `<span class="visually-hidden">${count} items in cart</span>`;
      return;
    }

    const cartIconButton = document.getElementById('cart-icon-bubble');
    if (cartIconButton && count > 0) {
      const bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML =
        count < 100
          ? `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items in cart</span>`
          : `<span class="visually-hidden">${count} items in cart</span>`;
      cartIconButton.appendChild(bubble);
    }
  }

  function syncCartDrawerOverlay(cartDrawer) {
    const overlay = cartDrawer && cartDrawer.querySelector('#CartDrawer-Overlay');
    if (!overlay || typeof cartDrawer.close !== 'function') return;

    overlay.onclick = cartDrawer.close.bind(cartDrawer);
  }

  function replaceCartDrawer(sectionHtml) {
    const parsedDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const newDrawer = parsedDocument.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (!newDrawer || !currentDrawer) return;

    const wasOpen = currentDrawer.classList.contains('active');
    currentDrawer.className = newDrawer.className;
    currentDrawer.innerHTML = newDrawer.innerHTML;
    syncCartDrawerOverlay(currentDrawer);

    if (wasOpen) {
      currentDrawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }

  async function refreshCartDrawer() {
    if (refreshInFlight) return;

    refreshInFlight = true;

    try {
      const [drawerResponse, cartResponse] = await Promise.all([
        fetch(`${getCartUrl()}?section_id=cart-drawer`, { cache: 'no-store' }),
        fetch('/cart.js', { cache: 'no-store' }),
      ]);

      if (drawerResponse.ok) {
        const drawerHtml = await drawerResponse.text();
        replaceCartDrawer(drawerHtml);
      }

      if (cartResponse.ok) {
        const cartData = await cartResponse.json();
        updateHeaderCartCount(cartData);
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && !cartDrawer.classList.contains('active') && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    } finally {
      refreshInFlight = false;
    }
  }

  function scheduleCartRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartDrawer, 1000);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    const wiserAddToCart = event.target.closest(WISER_ATC_SELECTORS.join(','));
    if (!wiserAddToCart) return;

    scheduleCartRefresh();
  });

  window.addEventListener('wiser:cartUpdated', function () {
    clearTimeout(refreshTimer);
    refreshCartDrawer();
  });
})();

// google merchant widget script 

function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (encodeURIComponent(value) || '') + expires + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }
  window.addEventListener('load', function () {
    // 30-day suppression key
    var COOKIE_KEY = 'merchant_badge_seen';
    var COOKIE_DAYS = 30;
    // If badge was already shown, exit early
    if (getCookie(COOKIE_KEY)) return;

    setTimeout(function () {
      const script = document.createElement('script');
      script.id = 'merchantWidgetScript';
      script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
      script.defer = true;
      document.body.appendChild(script);
      script.addEventListener('load', function () {
      var isProductTemplate = document.body.classList.contains('template--product');
      try {
        merchantwidget.start({
          position: 'LEFT_BOTTOM',
          sideMargin: 21,
          bottomMargin: isProductTemplate ? 60 : 20,
          mobileSideMargin: 21,
          mobileBottomMargin: 60,
        });
      } catch (e) {
        console.warn('merchantwidget.start error', e);
      }

      // ---- Observing widget appearance to adjust z-index when it expands ----
      const tryObserve = () => {
        const widget = document.querySelector('#google-merchantwidget-iframe-wrapper');
        if (!widget) {
          // Try again after a short delay — widget may not have rendered yet
          setTimeout(tryObserve, 500);
          return;
        }

        const observer = new MutationObserver(() => {
          const height = widget.offsetHeight;
          const width = widget.offsetWidth;

          // When widget expands (usually > 100px)
          if (height > 100 || width > 150) {
            widget.style.zIndex = '2147483647'; // reduce z-index when open
          } else {
            widget.style.zIndex = '8';
          }
        });

        observer.observe(widget, { attributes: true, attributeFilter: ['style'] });
      };

      // Start observing once widget likely appears
      setTimeout(tryObserve, 1000);

      // Mark the badge as shown for session and set 30-day cookie
      try {
        setCookie(COOKIE_KEY, '1', COOKIE_DAYS);
      } catch (e) {}
      });
    }, 1500);
  });